import { FC } from 'react';

import DescriptionIcon from '@mui/icons-material/Description';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const PagesCard: FC = () => (
  <ToolCard
    icon={<DescriptionIcon fontSize="large" />}
    title="Puslapiai"
    description="Svetainės puslapių administravimas"
    action={
      <Button href="pages" startIcon={<DescriptionIcon />} size="small">
        Administruoti
      </Button>
    }
  />
);

export default PagesCard;
